// extracted by mini-css-extract-plugin
export default {"text":"G3IiU__text"};